<template>
  <v-dialog v-model="dialog" width="550" persistent>
    <v-card v-if="item">
      <v-toolbar color="error" dense dark class="elevation-0">
        <v-toolbar-title>Từ chối Yêu cầu Mượn Thiết bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <div class="mb-3">
            Từ chối phiếu mượn <strong>{{ item.code }}</strong> của người mượn <strong>{{ item.borrowerName }}</strong>.
          </div>

          <v-textarea
            v-model="rejectReason"
            placeholder="Nhập lý do từ chối (VD: Thiết bị đang trong quá trình bảo dưỡng, thiếu thông tin...)"
            outlined
            dense
            rows="3"
            :rules="[v => !!v || 'Vui lòng nhập lý do từ chối']"
          >
            <template v-slot:label>
              Lý do từ chối <span class="red--text font-weight-bold">*</span>
            </template>
          </v-textarea>
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="dialog = false">Hủy</v-btn>
        <v-spacer />
        <v-btn color="error" depressed :loading="loading" @click="onConfirm">
          <v-icon left small>mdi-close</v-icon> Xác nhận từ chối
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BorrowRejectDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: true,
      rejectReason: ''
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.rejectReason = ''
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    }
  },
  methods: {
    ...mapActions('FacilityBorrows', ['rejectBorrow']),
    async onConfirm() {
      if (!this.$refs.form.validate()) return
      if (!this.item || !this.item.id) return

      this.loading = true
      try {
        const res = await this.rejectBorrow({
          id: this.item.id,
          rejectReason: this.rejectReason
        })
        if (res) {
          this.dialog = false
          this.$emit('updated')
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
